import _ from 'lodash';
import Component from '../classes/component';

enum FeedbackType {
  error,
  success,
  warning,
}

const feedbackTypes = Object.keys(FeedbackType);

const SELECTORS = {
  content: '.content',
  feedback: '.feedback',
};

class StatefulButton extends Component<typeof SELECTORS, HTMLButtonElement> {
  protected _selectors = SELECTORS;

  public get isDisabled() {
    return this.container.disabled;
  }

  public get isLoading() {
    return this.container.classList.contains('is-loading');
  }

  public set isLoading(isLoading: boolean) {
    this.container.classList[isLoading ? 'add' : 'remove']('is-loading');
  }

  public enable() {
    this.container.disabled = false;
  }

  public disable() {
    this.container.disabled = true;
  }

  public enableIf(condition: boolean) {
    if (condition) this.enable();
  }

  public disableIf(condition: boolean) {
    if (condition) this.disable();
  }

  public hideFeedback() {
    this.container.classList.remove(...feedbackTypes, 'show-feedback');
    this._getChild('feedback').innerText = '';
  }

  public showFeedback(text: string, type: keyof typeof FeedbackType, duration?: number) {
    this._getChild('feedback').innerText = text;
    this.container.classList.remove(...feedbackTypes);
    this.container.classList.add(type, 'show-feedback');
    if (duration) _.debounce(this.hideFeedback.bind(this), duration)();
  }
}

export default StatefulButton;
